<template>
  <div>
    <button v-if="is_show_filter" v-on:click="is_show_filter=false" class="artist-person__hide">{{ $t('message.FilterHide') }}</button>
    <button v-if="!is_show_filter" v-on:click="is_show_filter=true" class="artist-person__hide">{{ $t('message.FilterShow') }}</button>

    <div class="all-work__main" id="id_main_works_list">
      <div :class="get_filter_class">
        <works-filter-sub
          :filters="filters"
          v-on:filterChanged="filterChanged"/>
      </div>

      <div class="works-list">
        <div class="artist-person__information">
          <works-tags-sub/>
        </div>
        <div class="artist-person__information">
          <div class="works-filter__tags"/>
          <sort-type-sub/>
        </div>

        <div v-show="worksLoading" style="margin-top: 40px">
          <preloader/>
        </div>
        <works-list v-show="!worksLoading" :is_mark_work_pro="is_mark_work_pro"/>
        <!--<div v-if="is_copyright" v-show="!worksLoading">
          {{ $t('message.ArtistCopyright') }}
        </div>-->

        <works-pagination-sub v-show="!worksLoading"/>
      </div>
    </div>
  </div>
</template>


<script>
  import SortTypeSub from "./list/filter/SortTypeSub";
  import WorksFilterSub from "./list/WorksFilterSub";
  import WorksTagsSub from "./list/WorksTagsSub";
  import WorksList from "../../../components/list/WorksList";
  import WorksPaginationSub from "./list/WorksPaginationSub";
  import Preloader from "../../../components/Preloader";
  import WorksMix from "../../../components/WorksMix";

  export default {
    components: {
      SortTypeSub,
      WorksFilterSub, WorksTagsSub, WorksList, Preloader, WorksPaginationSub,
    },
    name      : 'works-sub',
    mixins: [WorksMix],

    data() {
      return {
        is_show_filter: false,
      }
    },

    computed: {
      get_filter_class: {
        get () {
          return this.is_show_filter?'show_filter':'hide_filter';
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/WorksSub.vue